module.exports = __webpack_public_path__ + "static/img/PFK_Photo4_WaysHelp_2000x500.4bba97a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_Photo4_WaysHelp_2000x500.jpg
// module id = 341
// module chunks = 2